var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-modal',{attrs:{"id":"image-model","title":_vm.title,"hide-footer":""}},[(_vm.image)?_c('div',{staticClass:"m-auto text-center"},[_c('img',{staticClass:"img-fluid",attrs:{"src":_vm.image,"alt":""}})]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }